import httpService from '@/utils/request'
import { contextPath } from '@/config/'

export const createRoleApi = (data) => {
  return httpService({
    url: contextPath + '/user/role/item',
    method: 'post',
    data
  })
}

export const deleteRoleApi = (data) => {
  return httpService({
    url: contextPath + '/user/role/item',
    method: 'delete',
    data
  })
}

export const updateRoleApi = (data) => {
  return httpService({
    url: contextPath + '/user/role/item',
    method: 'put',
    data
  })
}

export const queryRoleApi = (params) => {
  return httpService({
    url: contextPath + '/user/role/info',
    method: 'get',
    params
  })
}

export const queryRoleByIdApi = (params) => {
  return httpService({
    url: contextPath + '/user/role/item',
    method: 'get',
    params
  })
}
